import styled from "styled-components";
import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "components/molecules/Button";
import EditableButton from "components/molecules/EditableButton";
import UnitSwitch from "components/molecules/UnitSwitch";

import ToolContext from "components/services/ToolContext";
import { buttonThemes } from "globalConstants/Themes";
import ReducersIndex from 'reduxModules/ducks';

import Save from "components/services/Save";
import Export from "components/services/Export";

const ControlBar = ({silentSave, setSilentSave}) => {
  const tool = useContext(ToolContext);
  const tabs = useSelector(state => state.ui.tabs);
  const activeTab = useSelector(state => state.ui.activeTab);
  const dispatch = useDispatch();

  const handleTabClick = (evt, tab) => {
    dispatch(ReducersIndex.uiReducers.setActiveTab(tab));
    if (tool.constants.tool.containerName && tabs.at(0).id === tab) dispatch(ReducersIndex.uiReducers.setZoom(false));
  };

  const handleAdd = (evt) => {
    dispatch(ReducersIndex.container.addArea());
    dispatch(ReducersIndex.uiReducers.openModal('area'));
  };

  const handleReset = (evt) => { 
    dispatch(ReducersIndex.uiReducers.openModal('resetArea'));
  };

  const showAdd = useSelector(state => state.ui.allowAddArea);   

  return (
    <ControlBar.Wrapper>
      <div className={"col-9 hstack gap-0 p-0 fw-bold mw-75"}>
        {tabs.map((tab, index) => (
          <EditableButton key={`${tab.id}-${index}`} id={tab.id} active={activeTab === tab.id} onClick={(e) => handleTabClick(e, tab.id)} />
        ))}
        {showAdd && (<Button id={'addRoom'} className="fs-6" theme={buttonThemes.nav_light} label={`ADD ${tool.constants.tool.addAreaLabel} +`} onClick={handleAdd} />
        )}
      </div>
      <div className="col-3 hstack gap-0 p-0 d-flex justify-content-end fs-6">
        <UnitSwitch nomargin />
        <Button theme={buttonThemes.nav_light} label={"RESET"} onClick={handleReset} />
        <Save silentSave={silentSave} setSilentSave={setSilentSave} />
        <Export silentSave={silentSave} setSilentSave={setSilentSave} />
      </div>
    </ControlBar.Wrapper>
  );
};
ControlBar.Wrapper = styled.div.attrs((props) => ({
  className: "row justify-content-between",
}))`
    max-height: 38px;
    border: 1px solid #000;
    border-style: solid none solid none;
    font-size: 22px;
`;

export default ControlBar;